<template>
  <div class="vr-view">
    <div class="vr-box">
      <div :class="['iframe-box',{big:size === 'big'}]">
        <iframe
          class="iframe"
          :src="vrUrl"
          frameborder="0"
        >
        </iframe>
        <div v-if="btnShow" class="change-btn" @click="changeSize">
          <img class="screen_icon" alt="icon" :src="screenIconUrl" />
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import swTracker from '@/mixins/tracker.js'

export default {
  name: "VrView",
  mixins: [swTracker],
  data () {
    return {
      vrUrl: '',
      size: 'small',
      type: '', // 默认移动端、pc为电脑端
      btnShow: false,
    }
  },
  computed: {
    btnText () {
      return this.size === 'small' ? '全屏' : '小屏'
    },
    screenIconUrl () {
      return this.size === 'small' ? 'https://xfjoss.coli688.com/admin/image/screen_big_icon.png' : 'https://xfjoss.coli688.com/admin/image/screen_small_icon.png'
    },
  },
  watch: {
    type (val) {
      if(val === 'pc') {
        this.size = 'big'
      }
    },
  },
  created () {
    setTimeout(() => {
      this.btnShow = true
    }, 2500)
    this.vrUrl = this.$route.query.vrUrl
    this.type = this.$route.query.type
  },
  methods: {
    changeSize(){
      this.size = this.size === 'small' ? 'big' : 'small'
    }
  }
}
</script>
<style lang="scss" scoped>
.vr-box{
  width: 100%;
  height: 100vh;
  min-height: 700px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-content: center;
}
.iframe-box{
  width: 500px;
  height: 100%;
  position: relative;
  &.big{
    width: 100%;
  }
}
.iframe{
  width: 100%;
  height: 100%;
}
.change-btn{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(9, 9, 9, 0.6);
  cursor: pointer;
  position: absolute;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  top: 10px;
  right: 50px;
  .screen_icon{
    width: 20px;
    height: 20px;
  }
}
</style>